import { push } from 'react-router-redux';
import { updateObject } from '../storeFunctions';
import { bottomWindowActionMap, bottomWindowChartActions } from './bottomWindow/actions';
import { bottomWindowInitialState } from './bottomWindow/initial';
import { customChartActions } from './custom/actions';
import { diagramActionMap, diagramChartActions } from './diagram/actions';
import { diagramInitialState } from './diagram/initial';
import { exportActionMap, exportChartActions } from "./exports/actions";
import { exportsInitialState } from "./exports/initial";
import { leftPanelActionMap, leftPanelChartActions } from './leftPanel/actions';
import { leftPanelInitialState } from './leftPanel/initial';
import { tooltipsActionMap } from './tooltips/actions';
import { tooltipInitialState } from './tooltips/initial';
import { topPanelActionMap, topPanelChartActions } from './topPanel/actions';
import { topPanelInitialState } from './topPanel/initial';
import { visualizationActionMap, visualizationChartActions } from './visualizations/actions';
import { visualizationsInitialState } from './visualizations/initial';

const initialState = {
    ...diagramInitialState,
    ...topPanelInitialState,
    ...leftPanelInitialState,
    ...bottomWindowInitialState,
    ...tooltipInitialState,
    ...exportsInitialState,
    ...visualizationsInitialState,
}

const actionMap = {
    //inhouse actions
    ...diagramActionMap,
    ...topPanelActionMap,
    ...leftPanelActionMap,
    ...bottomWindowActionMap,
    ...tooltipsActionMap,
    ...exportActionMap,
    ...visualizationActionMap,
    //outer reactions
    WINDOW_RESIZE: (state, data) => updateObject(state, { sizeChanged: true })
}

export const reducer = (state, action) => {
    state = state || initialState;
    if (Object.keys(actionMap).indexOf(action.type) !== -1) {
        return actionMap[action.type](state, action.data)
    }
    return state;
}

let chartActions = {
    redirect: (url) => async (dispatch) => dispatch(push(url))
};
chartActions = Object.assign(chartActions, diagramChartActions);
chartActions = Object.assign(chartActions, customChartActions);
chartActions = Object.assign(chartActions, topPanelChartActions);
chartActions = Object.assign(chartActions, leftPanelChartActions);
chartActions = Object.assign(chartActions, bottomWindowChartActions);
chartActions = Object.assign(chartActions, exportChartActions);
chartActions = Object.assign(chartActions, visualizationChartActions);

export { chartActions };
